var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpeechbubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4c1.6569 0 3 1.3431 3 3v7c0 1.6569-1.3431 3-3 3h-6.5895l-3.9968 4H6v-4H5c-1.6568 0-3-1.3431-3-3V7c0-1.6569 1.3432-3 3-3h14zm1 3c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1v7c0 .5523.4477 1 1 1h3v3.5845L11.5817 15H19c.5523 0 1-.4477 1-1V7z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeechbubble);
export default __webpack_public_path__ + "static/media/icon-speechbubble.50487d7386146f21785d6f6926c42529.svg";
export { ForwardRef as ReactComponent };